/**
 * @fileoverview Custom loading spinner component.
 */
import React from 'react';
import StyledLoadingSpinner from './LoadingSpinner.styles';

const LoadingSpinner: React.FC = () => (
  <StyledLoadingSpinner className="bl-loading-spinner">
    <svg width="40px" height="40px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30" />
    </svg>
  </StyledLoadingSpinner>
);

export default LoadingSpinner;
